import React, { FC } from 'react';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { Box, Typography, useTheme } from '@mui/material';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import ReviewFooter from '../ReviewFooter';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import ReviewText from '../ReviewText';
import { Person } from '@mui/icons-material';

interface Props extends IReviewNewProps {}

const EbayReview: FC<Props> = ({
  communityManagement,
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  const { name, ratingValue, reviewText, reviewTitle, companyComment } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={ratingValue}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {name && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          >
            {name}
          </Typography>
        </Box>
      )}
      {reviewTitle && (
        <Typography
          variant="h6"
          sx={{ mt: theme.spacing(2) }}
        >
          {reviewTitle}
        </Typography>
      )}
      <ReviewText text={reviewText} />
    </ReviewWrapper>
  );
};

export default EbayReview;
